import React from 'react'
import { Page, Text, Document, StyleSheet, Image } from '@react-pdf/renderer';

export default function PdfChoices(props) {

    const { Lundi, Mardi, Mercredi, Jeudi, Vendredi, Samedi, Dimanche } = props.daysData;

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            width: "100%",
            padding: 10
        },
        part: {
            flexDirection: 'column',
            marginTop: 10,
            alignItems: "center"
        },
        text: {
            fontSize: 15,
        },
        title: {
            fontSize: 20,
        },
        Day: {
            fontSize: 17,
            textDecoration: "underline"
        }
    })

    const LundiMenu = Lundi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Lundi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const MardiMenu = Mardi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mardi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const MercrediMenu = Mercredi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Mercredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const JeudiMenu = Jeudi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Jeudi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const VendrediMenu = Vendredi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Vendredi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const SamediMenu = Samedi.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Samedi</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    const DimancheMenu = Dimanche.map((d) => 
    <view style={styles.part}>
        <Text>----------------------------------------------------------------------------------------------</Text>
        <Text style={styles.Day}>Dimanche</Text>
        <Text style={styles.text}>{d.date}</Text><br/>
        <Text style={styles.text}>{d.entree}</Text><br/>
        <Text style={styles.text}>{d.plat}</Text><br/>
        <Text style={styles.text}>{d.laitage}</Text><br/>
        <Text style={styles.text}>{d.dessert}</Text><br/>
        <Text style={styles.text}>{d.potage} {d.potagenbr === undefined || d.potagenbr === "0" || d.potagenbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.potagenbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.brick} {d.bricknbr === undefined || d.bricknbr === "0" || d.bricknbr === "1" ? null : <Text style={{fontFamily: "Helvetica-Bold"}}>&#40;{d.bricknbr}&#41;</Text>}</Text><br/>
        <Text style={styles.text}>{d.diner}</Text><br/>
        {d.boule === "0" ? null : <Text style={styles.text}>{d.boule} boule</Text>}
        {d.baguette === "0" ? null : <Text style={styles.text}>{d.baguette} baguette</Text>}
        {d.nature === "0" ? null : <Text style={styles.text}>{d.nature} pain de mie nature</Text>}
        {d.complet === "0" ? null : <Text style={styles.text}>{d.complet} pain de mie complet</Text>}
    </view>);

    return (
        <Document title="RecapMenu.pdf">
            <Page style={styles.page} size="A4" orientation='portrait'>
                <Image src="/logo.png" style={{width: '10vh', alignSelf: "center"}}/>
                <Text style={styles.title}>{props.client_infos.gender} {props.client_infos.firstname} {props.client_infos.name}</Text>
                <view wrap={false} style={styles.part}>{LundiMenu}</view>
                <view wrap={false} style={styles.part}>{MardiMenu}</view>
                <view wrap={false} style={styles.part}>{MercrediMenu}</view>
                <view wrap={false} style={styles.part}>{JeudiMenu}</view>
                <view wrap={false} style={styles.part}>{VendrediMenu}</view>
                <view wrap={false} style={styles.part}>{SamediMenu}</view>
                <view wrap={false} style={styles.part}>{DimancheMenu}</view>
            </Page>
        </Document>
    )
}